import axios from 'axios';
import { toast } from 'react-toastify';
import { config } from './utils';

const ensureBearerToken = (token: string) => {
  if (!token) return '';
  return token.startsWith('Bearer ') ? token : `Bearer ${token}`;
};

/** Max upload size for admin image assets (matches typical nginx / server limit). */
export const MAX_UPLOAD_FILE_SIZE_MB = 5;
export const MAX_UPLOAD_FILE_SIZE_BYTES = MAX_UPLOAD_FILE_SIZE_MB * 1024 * 1024;

const OVERSIZE_FILE_MESSAGE = `Image size must be lower than ${MAX_UPLOAD_FILE_SIZE_MB}MB.`;

export const uploadAssets = async (
  file: File,
  uploadType: string,
  token: string
) => {
  if (file.size > MAX_UPLOAD_FILE_SIZE_BYTES) {
    toast.error(OVERSIZE_FILE_MESSAGE);
    return null;
  }

  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await axios.post(
      `${config.BASE_URL}/upload-asset?uploadType=${uploadType}`,
      formData,
      {
        headers: {
          Authorization: ensureBearerToken(token),
          // Do not set Content-Type manually — axios must add the multipart boundary
        },
      }
    );
    return response;
  } catch (error: any) {
    const status = error?.response?.status;
    const responseText = String(
      error?.response?.data?.message || error?.response?.data || ''
    );
    // nginx often returns 413 with Connection: close → axios has no response (Network Error)
    const isNetworkDrop =
      !error?.response &&
      (error?.code === 'ERR_NETWORK' ||
        /network error/i.test(String(error?.message || '')));
    const isTooLarge =
      status === 413 ||
      isNetworkDrop ||
      /entity too large|file too large|payload too large/i.test(responseText);

    const message = isTooLarge
      ? OVERSIZE_FILE_MESSAGE
      : error?.response?.data?.message ||
        error?.message ||
        'Image upload failed';

    toast.error(typeof message === 'string' ? message : 'Image upload failed');
    console.error('uploadAssets error', error);
    return null;
  }
};
